__turbopack_context__.v({
  "container": "SearchInput-module__9jKS-G__container",
  "escapeButton": "SearchInput-module__9jKS-G__escapeButton",
  "icon": "SearchInput-module__9jKS-G__icon",
  "input": "SearchInput-module__9jKS-G__input",
  "kbd": "SearchInput-module__9jKS-G__kbd",
});
